import styled from 'styled-components';

export const PanelHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  font-weight: 600;
`;

export const PanelBody = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ParticipantRow = styled.div`
  padding: 8px 10px;
  border-radius: 8px;
  background: ${({ $self }) => ($self ? 'rgba(46,170,199,0.14)' : 'rgba(255,255,255,0.04)')};
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 13px;
`;

export const ParticipantRowHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 32px;
`;

export const ParticipantRowName = styled.div`
  min-width: 0;
  font-weight: 600;
`;

export const ParticipantRowStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const ParticipantStatusLabel = styled.div`
  font-size: 11px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #d6e2ed;
`;

export const ParticipantStatusIcons = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const ChatPlaceholder = styled.div`
  padding: 16px;
  color: #9fb0c2;
  font-size: 13px;
`;
